import * as serviceContext from './serviceContext';
import { BASE_URL_M_ADMIN } from '../config';


let options = {};
let headers = new Headers();
const token = sessionStorage.getItem('token');

headers.append('content-type', 'application/json')
headers.append('Authorization', `${token}`);

options.headers = headers;
options.redirect = 'follow';


export async function getAllLicenses(){
    try {
        const response = await serviceContext.get(`${BASE_URL_M_ADMIN}madmin/licensemaster`, null, options);
        const res = response.json();
        return res;
    } catch (error) {
        return error;
    }
}

export async function createLicence(body){
    try {
        const response = await serviceContext.post(`${BASE_URL_M_ADMIN}madmin/licensemaster`, JSON.stringify(body), options);
        const res = response.json();
        return res;
    } catch (error) {
        return error;
    }
}

export async function updateLicence(body){
    try {
        const response = await serviceContext.put(`${BASE_URL_M_ADMIN}madmin/licensemaster`, JSON.stringify(body), options);
        const res = response.json();
        return res;
    } catch (error) {
        return error;
    }
}

export async function getLicenseById(licenseId){
    try {
        const response = await serviceContext.get(`${BASE_URL_M_ADMIN}madmin/licensemaster/${licenseId}`, null, options);
        const res = response.json();
        return res;
    } catch (error) {
        return error;
    }
}

export async function getOperators(){
    try {
        const response = await serviceContext.get(`${BASE_URL_M_ADMIN}madmin/licensemaster/getoperators`, null, options);
        const res = response.json();
        return res;
    } catch (error) {
        return error;
    }
}

export async function getuserDetailById(operatorId, licenseId){
    try {
        const response = await serviceContext.get(`${BASE_URL_M_ADMIN}madmin/licensemaster/adminuserstatus/${operatorId}/${licenseId}`, null, options);
        const res = response.json();
        return res;
    } catch (error) {
        return error;
    }
}

export async function updateUserPassword(body){
    try {
        const response = await serviceContext.put(`${BASE_URL_M_ADMIN}madmin/licensemaster/resetadminuserpassword`, JSON.stringify(body), options);
        const res = response.json();
        return res;
    } catch (error) {
        return error;
    }
}

export async function updateUserStatus(body){
    try {
        const response = await serviceContext.put(`${BASE_URL_M_ADMIN}madmin/licensemaster/adminuserstatus`, JSON.stringify(body), options);
        const res = response.json();
        return res;
    } catch (error) {
        return error;
    }
}

export async function syncModules(id) {
    try {
        const response = await serviceContext.put(`${BASE_URL_M_ADMIN}madmin/modulemaster/syncmoduels/${id}`, null, options);
        const res = response.json();
        return res;
    } catch (error) {
        return error;
    }
}

export async function getConnectionStatus(id) {
    try {
        const response = await serviceContext.get(`${BASE_URL_M_ADMIN}madmin/licensemaster/testconnection/${id}`, null, options);
        const res = response.json();
        return res;
    } catch (error) {
        return error;
    }
}

export async function syncLicenceVersion(id) {
    try {
        const response = await serviceContext.get(`${BASE_URL_M_ADMIN}madmin/licenseversion/sync/${id}`, null, options);
        const res = response.json();
        return res;
    } catch (error) {
        return error;
    }
}

export async function submitLicencePackages(data) {
    try {
        const response = await serviceContext.put(`${BASE_URL_M_ADMIN}madmin/licensemaster/packages`, JSON.stringify(data), options);
        const res = response.json();
        return res;
    } catch (error) {
        return error;
    }
}